import request from '#api/axios';
import { IDegree } from '#types/account';

export const postDegrees = async (payload: IDegree) => {
  const res = await request({
    method: 'post',
    url: '/degrees',
    data: payload
  });

  return res.data;
};

/**
 * 학력 상세 조회하기
 */
export const getDegree = async (degreeId: string) => {
  const res = await request<{
    name: string;
    major: string;
    from: Date;
    at?: Date;
    diplomaNumber: string | null;
  }>({
    method: 'get',
    url: `/degrees/${degreeId}`
  });

  return res.data;
};

export const deleteDegrees = async (id: string) => {
  const res = await request({
    method: 'delete',
    url: `/degrees/${id}/delete`
  });

  return res.data;
};
